export default defineNuxtPlugin( async (nuxtApp) => {
  const config = useRuntimeConfig()

  const  { session, refresh} = await useSession()

 
    const apiAuthCustomer = $fetch.create({
      baseURL: process.server ? config.apiInternalBase : config.public.API_BASE_URL_WEB,
       credentials: 'omit',                              // Bearer -> bez kolačića
      headers: { Accept: 'application/json' },
    async onRequest({ request, options, error }) {

      await refresh()

     const token = session.value?.tokenCustomer

     if (!token) return
    const h = (options.headers ||= {})
    
    if (Array.isArray(h)) h.push(['Authorization', `Bearer ${token}`])
    else if (h instanceof Headers) h.set('Authorization', `Bearer ${token}`)
    else h.Authorization = `Bearer ${token}`

    },
    async onResponseError({ response }) {
      if (response.status === 401) {
        await nuxtApp.runWithContext(() => navigateTo('/login'))
      }
    }
  })
    // Expose to useNuxtApp().$api
// const config = useRuntimeConfig()

//   const getCookie = (name: string): string | null => {
//     if (process.client) {

//       const value = `; ${document.cookie}`;
//       const parts = value.split(`; ${name}=`);

//       if (parts.length === 2) {

//         return parts.pop()?.split(';').shift() ?? null;

//       }
//     }

//     if (process.server) {

//       const cookie = nuxtApp.ssrContext?.event.node.req.headers.cookie

//       if (!cookie) return null

//       const regex = new RegExp(`${name}=([^;]+)`)
//       const match = cookie.match(regex)

//       return match ? decodeURIComponent(match[1]) : null

//     }

//     return null
//   }

//   const ensureCsrfToken = async () => {

//     const token = getCookie('XSRF-TOKEN')
    
//     if (!token) {

//       await $fetch('/sanctum/csrf-cookie', {
//         baseURL: config.public.API_BASE_URL_WEB,
//         credentials: 'include'
//       })

//     }
//   }

   
//     const apiAuthCustomer = $fetch.create({
//        baseURL: config.public.API_BASE_URL_WEB,
//        credentials: 'include',
//     async onRequest({ options }) {

//       await ensureCsrfToken()

//       const token = getCookie('XSRF-TOKEN')

//       if (token) {
//         const headers = options.headers ||= {}
//         if (Array.isArray(headers)) {

//           headers.push(['X-XSRF-TOKEN', decodeURIComponent(token)])

//         } else if (headers instanceof Headers) {

//           headers.set('X-XSRF-TOKEN', decodeURIComponent(token))

//         } else {
          
//           headers['X-XSRF-TOKEN'] = decodeURIComponent(token)
//         }
//       }
//     },
//     async onResponseError({ response }) {

 
 
//       if (response.status === 401) {
//         await nuxtApp.runWithContext(() => navigateTo('/login'))
//       }
      
//       if (response.status === 419) {
//          await nuxtApp.runWithContext(() => navigateTo('/login'))
//       }

//       if (response._data.message === 'User is not logged in.') {
//          await nuxtApp.runWithContext(() => navigateTo('/login'))
//       }
//     }
//   })

    return {
      provide: {
        apiAuthCustomer
      }
    }
  })
  
